(() => {
  if (window.FourPawV6VideoToggle) {
    window.FourPawV6VideoToggle.scan();
    return;
  }

  const cleanups = new WeakMap();
  const init = (button) => {
    if (!(button instanceof HTMLButtonElement) || cleanups.has(button)) return;
    const video = button.closest('[data-fp-video-frame]')?.querySelector('[data-fp-lazy-video]');
    const source = video?.querySelector('source[data-src]');
    if (!video || !source) return;

    const icon = button.querySelector('[data-fp-video-toggle-icon]');
    const playLabel = button.dataset.playLabel || 'Play video';
    const pauseLabel = button.dataset.pauseLabel || 'Pause video';
    const sync = () => {
      const isPlaying = !video.paused && !video.ended;
      button.dataset.state = isPlaying ? 'playing' : 'paused';
      button.setAttribute('aria-label', isPlaying ? pauseLabel : playLabel);
      button.setAttribute('aria-pressed', String(isPlaying));
      if (icon) icon.textContent = isPlaying ? 'Ⅱ' : '▶';
    };
    const hydrate = () => {
      if (source.getAttribute('src')) return;
      if (video.dataset.poster && !video.poster) video.poster = video.dataset.poster;
      source.src = source.dataset.src;
      video.load();
    };
    const toggle = () => {
      if (video.paused || video.ended) {
        video.dataset.autoplay = 'true';
        hydrate();
        video.play().catch(sync);
      } else {
        video.dataset.autoplay = 'false';
        video.pause();
      }
      sync();
    };

    button.addEventListener('click', toggle);
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    video.addEventListener('ended', sync);
    sync();
    cleanups.set(button, () => {
      button.removeEventListener('click', toggle);
      video.removeEventListener('play', sync);
      video.removeEventListener('pause', sync);
      video.removeEventListener('ended', sync);
      cleanups.delete(button);
    });
  };
  const scan = (scope = document) => {
    if (scope.matches?.('[data-fp-video-toggle]')) init(scope);
    scope.querySelectorAll?.('[data-fp-video-toggle]').forEach(init);
  };
  const unload = (scope) => {
    if (scope.matches?.('[data-fp-video-toggle]')) cleanups.get(scope)?.();
    scope.querySelectorAll?.('[data-fp-video-toggle]').forEach((button) => cleanups.get(button)?.());
  };

  window.FourPawV6VideoToggle = Object.freeze({ scan });
  scan();
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:unload', (event) => unload(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    scan(event.target.closest?.('[data-fp-video-band]') || event.target);
  });
})();
